function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  width: 19,
  height: 19,
  fill: "#9BADBC",
  rx: 9.5
}), React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11 14L6 9.5 11 5"
}));

var SvgBackButton = function SvgBackButton(props) {
  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19"
  }, props), _ref);
};

export default SvgBackButton;